declare global {
   interface Console {
      logOrigin: typeof console.log;
      errorOrigin: typeof console.error;
      logs: any[];
   }
}

console.logOrigin = console.log.bind(console);
console.errorOrigin = console.error.bind(console);

console.logs = [];

console.log = (...args) => {
   console.logOrigin(...args);
   if (args[2] && args[0].indexOf('state') >= 0) {
      return;
   }
   console.logs.push(args);
};

console.error = (...args) => {
   console.errorOrigin(...args);
   console.logs.push(args);
};

export default console;
